<template>
  <el-table :data="products">
    <el-table-column class-name="pl-2">
      <template slot-scope="{row: {product: {image}}}">
        <div v-if="image">
          <img :src="image.src.replace('.png', '_200x.png')"
               :alt="image.handle"
               class="img-responsive"/>
        </div>
      </template>
    </el-table-column>

    <el-table-column label="Product"
                     align="center"
                     header-align="center">
      <template slot-scope="{row: {product, lineItem}}">
        <order-product-detail :product="product"
                              :lineItem="lineItem"/>
      </template>
    </el-table-column>

    <el-table-column label="Quantity"
                     prop="d365Item.OrderedSalesQuantity"
                     align="center"
                     header-align="center"/>

    <el-table-column label="Price"
                     align="center"
                     header-align="center">
      <template slot-scope="{row: {lineItem, d365Item}}">
        <price-display
            :originalPrice="Number(lineItem.price)"
            :updatePrice="Number(d365Item.SAXXNetUnitPrice)"
        />
      </template>
    </el-table-column>
    <el-table-column label="Total"
                     align="center"
                     header-align="center">
      <template slot-scope="{row: {lineItem, d365Item}}">
        <price-display
            :originalPrice="Number(lineItem.price * lineItem.quantity)"
            :updatePrice="Number(d365Item.SAXXNetUnitPrice * d365Item.OrderedSalesQuantity)"
        />
      </template>
    </el-table-column>
    <el-table-column label="Refund Quantity"
                     align="center"
                     header-align="center">
      <template slot-scope="{$index, row: {returnItem}}">
        <el-input :value="returnItem.quantity"
                  :disabled="disabled||returnItem.status=='Invoiced'"
                  :class="{'el-input-border--danger': inValidProductQuantity($index)}"
                  class="el-input--underline el-input--underline-center"
                  size="mini"
                  @input="(value) => updateProductValue(value, $index, 'quantity')"/>
      </template>
    </el-table-column>
    <el-table-column label="Refund Amount"
                     prop="price"
                     align="center"
                     header-align="center">
      <template slot-scope="{row: {d365Item, returnItem, exchange}}">
        {{calculateRefundAmount(d365Item, returnItem, exchange) | currency}}
      </template>
    </el-table-column>
    <el-table-column label="Available for Refund"
                     align="center"
                     header-align="center">
      <template slot-scope="{row: {returnItem, d365Item, exchange}}">
        {{calculateAvailableForRefund(d365Item, returnItem, exchange) | currency}}
      </template>
    </el-table-column>
    <el-table-column>
      <template slot-scope="{$index, row}">
        <el-checkbox :disabled="disabled"
                     :value="row.exchange"
                     @change="handleExchange($event, $index, row)">Exchange
        </el-checkbox>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  import {mapState, mapMutations} from 'vuex';
  import {currency} from '../../../filters';
  import InputMaskedPrice from '../Shared/InputMaskedPrice';
  import OrderProductDetail from '../Shared/OrderProductDetail';
  import PriceDisplay from '../Shared/PriceDisplay';
  import {
    ORDER_RETURN_SET_PRODUCT_UPDATE,
  } from '../../../store/modules/order/return/types';

  export default {
    name: 'OrderReturnProducts',
    inject: ['$v'],
    components: {
      InputMaskedPrice,
      OrderProductDetail,
      PriceDisplay,
    },
    filters: {
      currency,
    },
    computed: {
      ...mapState({
        products: state => state.orderReturn.products,
        isLoading: state => state.orderReturn.loading,
        isDiscountApplied: state => {
          return state.orderReturn.discount.price_rule !== null;
        },
      }),
      disabled() {
        return this.isDiscountApplied || this.isLoading;
      },
    },
    methods: {
      ...mapMutations({
        updateProduct: ORDER_RETURN_SET_PRODUCT_UPDATE,
        updateExchange: ORDER_RETURN_SET_PRODUCT_UPDATE,
      }),
      updateProductValue(value, index, type) {
        const returnItem = {
          ...this.products[index].returnItem, ...{
            [type]: Number(value),
          },
        };
        const product = {...this.products[index], ...{returnItem}};
        this.updateProduct({index, product});
        this.$v.products.$each[index].returnItem[type].$touch();
      },
      calculateAvailableForRefund(d365Item, returnItem, exchange) {
        const {OrderedSalesQuantity: d365SalesQuantity, SAXXNetUnitPrice: d365SalesPrice} = d365Item;
        const {quantity: returnItemQuantity, price: returnItemPrice} = returnItem;
        const d365ItemTotal = d365SalesQuantity * Number(d365SalesPrice);
        const returnItemTotal = returnItemQuantity * Number(returnItemPrice);

        if (exchange) {
          return d365ItemTotal;
        }

        return d365ItemTotal - returnItemTotal;
      },
      calculateRefundAmount(d365Item, returnItem, exchange) {
        if (exchange) {
          return 0;
        }
        return d365Item.SAXXNetUnitPrice * returnItem.quantity;
      },
      inValidProductQuantity(index) {
        return this.$v.products.$each[index].returnItem.quantity.$invalid;
      },
      handleExchange(exchange, index, product) {
        this.$v.products.$touch();
        this.updateExchange({index, product: {...product, ...{exchange}}});
      },
    },
  };
</script>
